<template>
  <el-dialog title="Liberar Repasse" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="700px" v-loading="loading">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="Data do Repasse">
            <el-date-picker v-model="dataPagamento" v-mask="'##/##/####'" type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy" style="width: 100%"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button @click="calcularRepasseHandler" type="primary" size="small" style="margin-top:17px;" round class="btn-box-shadow">Calcular</el-button>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="Valor">
            <money auto-complete="off" v-model="reciboRecuperado.valorPagamento" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Previsão Repasse">
            <el-input disabled :value="isProprietario && regraRepasse === 'DIAS_CORRIDOS' ? calcularDataRepasse(reciboRecuperado.dataVencimento, reciboRecuperado.carenciaRepasse) : reciboRecuperado.dataVencimento"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Forma de Pagamento" prop="formaPagamento">
            <el-select v-model="reciboRecuperado.formaPagamento" clearable value-key="data" placeholder="" filterable default-first-option style="width: 100%" :disabled="desabilitarAlterarFormaPagamentoRepasse">
              <el-option v-for="item in formasPagamento" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="depositoEmContaOuPix">
        <el-col :span="10">
          <el-form-item label="Conta Origem (Imobiliária)">
            <el-input size="small" v-model="labelContaBancariaImobiliaria" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button @click="exibirSelecionarContaBancariaOrigemDialog()" type="primary" icon="el-icon-search" size="small" style="margin-top: 17px" circle class="btn-box-shadow"/>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="depositoEmContaOuPix">
        <el-col :span="10">
          <el-form-item label="Conta para Depósito">
            <el-input size="small" v-model="labelContaParaDeposito" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button @click="exibirSelecionarContaBancariaDestinoDialog()" type="primary" icon="el-icon-search" size="small" style="margin-top: 17px" circle class="btn-box-shadow"/>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-table
            :data="reciboRecuperado.itensRecibo"
            empty-text="Nenhum item encontrado"
            size="small"
            height="150"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row>
            <el-table-column label="Tipo" prop="tipo" :formatter="labelTipoRecibo" width="150"/>
            <el-table-column label="Descrição" prop="nome"/>
            <el-table-column label="Valor" prop="valor" :formatter="labelValor" width="130"/>
          </el-table>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
        <el-button @click="liberarRepasseHandler" type="primary" size="small" round class="btn-box-shadow">Liberar Repasse</el-button>
    </span>
  
    <!-- CONTA ORIGEM (IMOBILIARIA) -->
    <app-selecionar-conta-bancaria-dialog @close="fecharSelecionarContaBancariaOrigemDialog" :cliente="undefined" v-if="reciboRecuperado" :visibility="visibilidadeSelecionarContaBancariaOrigemDialog" todosOsBancos/>
    <!-- CONTA DESTINO -->
    <app-selecionar-conta-bancaria-dialog @close="fecharSelecionarContaBancariaDestinoDialog" :cliente="clienteConta" v-if="reciboRecuperado" :visibility="visibilidadeSelecionarContaBancariaDestinoDialog" todosOsBancos/>
    <app-detalhes-lancamento-caixa-dialog @close="fecharDetalhesLancamentoCaixaDialog" @liberarRepasse="liberarViaImobiliaria" :recibo="reciboRecuperado" tipoRecibo="REPASSE" :totalDoAluguel="reciboRecuperado.valorPagamento" v-if="reciboRecuperado" :visibility="visibilidadeDetalhesLancamentoCaixaDialog"/>
  </el-dialog>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Util from '../../../util/funcoes.js';
import { FORMA_PAGAMENTO, TIPO_ITEM_RECIBO, BANCOS } from '../../../util/constantes.js';
import { Money } from "v-money";

import AppSelecionarContaBancariaDialog from '../../../shared/dialogs/SelecionarContaBancariaDialog.vue';  
import AppDetalhesLancamentoCaixaDialog from '../../../shared/dialogs/DetalhesLancamentoCaixaDialog.vue';  

export default {
  props: {
    recibo: Object,
    visibility: Boolean,
    formaPagamentoInicial: String,
    regraRepasse: String,
    isProprietario: Boolean
  },
  components: {
    AppSelecionarContaBancariaDialog,
    AppDetalhesLancamentoCaixaDialog,

    Money
  },
  created(){
    this.dataPagamento = Util.hoje()
    this.calcularRepasseHandler()
  },
  data() {
    return {
      reciboRecuperado: {
        dataProrrogacao: Date,
        itensRecibo: [],
        carenciaRepasse: null,
        dataVencimento: null
      },

      dataPagamento: Util.hoje(),
      calculado: false,

      contaBancariaOrigem: {
        id: 0,
        nome: ''
      },

      contaBancaria: {
        id: 0,
        nome: ''
      },

      clienteConta: {},

      validacao: {
        formaPagamento: [
          { type: "string", required: true }
        ]
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      visibilidadeSelecionarContaBancariaOrigemDialog: false,
      visibilidadeSelecionarContaBancariaDestinoDialog: false,
      visibilidadeDetalhesLancamentoCaixaDialog: false
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_ALUGUEL" })[0] }
    }),
    formasPagamento() {
      return FORMA_PAGAMENTO;
    },
    depositoEmContaOuPix() {
      return (this.reciboRecuperado.formaPagamento == "DEPOSITO_EM_CONTA") || (this.reciboRecuperado.formaPagamento == "PAGAMENTO_PIX")
    },
    recebidoNaImobiliaria() {
      return (this.reciboRecuperado.formaPagamento == "RECEBIMENTO_IMOBILIARIA")
    },
    acordo(){
      return (this.reciboRecuperado.formaPagamento == "ACORDO")
    },
    tipoItem() {
      return TIPO_ITEM_RECIBO;
    },
    desabilitarAlterarFormaPagamentoRepasse(){
      return !this.permissoes.alterarFormaPagamentoRepasse
    },
    loading() {
      return this.$store.state.loading;
    },
    labelContaParaDeposito() {
      return this.reciboRecuperado.formaPagamento === 'DEPOSITO_EM_CONTA' ? `${Util.getLabel(BANCOS, this.contaBancaria.banco) ? Util.getLabel(BANCOS, this.contaBancaria.banco) : ''} ${this.contaBancaria.conta ? ' - Conta: ' + this.contaBancaria.conta : ''}${this.contaBancaria.digitoConta ? '-' + this.contaBancaria.digitoConta : ''}` :
      this.reciboRecuperado.formaPagamento === 'PAGAMENTO_PIX' ? `Chave: ${this.contaBancaria.pix}` : " "
    },
    labelContaBancariaImobiliaria() {
      return `${this.contaBancariaOrigem.nome ? this.contaBancariaOrigem.nome : ''} ${this.contaBancariaOrigem.conta ? '- Conta: ' + this.contaBancariaOrigem.conta : ''}${this.contaBancariaOrigem.digitoConta ? '-' + this.contaBancariaOrigem.digitoConta : '' }`
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
        'calcularRepasseCliente',
        'listarContasBancariasCliente',
        'liberarRepasse'
    ]),
    iniciar() {
      this.dataPagamento = Util.hoje()
      this.calcularRepasseHandler()
    },
    calcularDataRepasse(dataVencimento, diasCarencia) {        
        if (!dataVencimento || diasCarencia == null || diasCarencia === 0 ) return dataVencimento;

        const partes = dataVencimento.split('/');
        const data = new Date(partes[2], partes[1] - 1, partes[0]);
        data.setDate(data.getDate() + diasCarencia);

        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();

        return `${dia}/${mes}/${ano}`;
    },
    calcularRepasseHandler() {
      if(!this.dataPagamento) {
        this.$message.warning("Insira a data de Pagamento!");
        return;
      }
        let payload = { id: this.recibo.id, dataPagamento: this.dataPagamento }

        this.showLoading();
        this.calcularRepasseCliente(payload)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.reciboRecuperado = resultado.item

                    if(resultado.item.contaBancariaOrigem) { this.contaBancariaOrigem.id = resultado.item.contaBancariaOrigem.id }
                    if(resultado.item.contaBancaria){ this.contaBancaria = resultado.item.contaBancaria }

                    this.calculado = true;

                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
    },
    liberarRepasseHandler() {
      if(this.reciboRecuperado.formaPagamento == 'DEPOSITO_EM_CONTA') {
        if(this.contaBancaria.id == 0) {
          this.$alert('Obrigatório selecionar uma conta para depósito', 'Atenção', { confirmButtonText: 'Ok' })
          return;
        }
      }
      if(this.recebidoNaImobiliaria) {
					this.exibirDetalhesLancamentoCaixaDialog();
				} else {
					this.liberarRepasseCliente();
				}
    },

    liberarViaImobiliaria(detalhesLancamento) {
      this.visibilidadeDetalhesLancamentoCaixaDialog = false
      this.reciboRecuperado.lancamentoCaixa = {}
      this.reciboRecuperado.lancamentoCaixa.detalhesLancamento = detalhesLancamento;
      this.liberarRepasseCliente()
    },

    liberarRepasseCliente() {
      if(this.dadosValidos()) {
        this.reciboRecuperado.dataPagamento = this.dataPagamento
        
        if(this.depositoEmContaOuPix) {
          this.reciboRecuperado.contaBancariaOrigem = this.contaBancariaOrigem
          this.reciboRecuperado.contaBancaria = this.contaBancaria
        } else {
          delete this.reciboRecuperado.contaBancariaOrigem;
          delete this.reciboRecuperado.contaBancaria;
        }
        
        if(this.recebidoNaImobiliaria && this.usuarioLogado.imobiliaria.parametros.lancarRepasseCaixa) {
          this.reciboRecuperado.lancamentoCaixa.operacao = 'SAIDA';
          this.reciboRecuperado.lancamentoCaixa.descricao = 'Repasse de Aluguel';
          this.reciboRecuperado.lancamentoCaixa.valor = this.reciboRecuperado.valorPagamento < 0 ? 0 : this.reciboRecuperado.valorPagamento;
        } else {
          delete this.reciboRecuperado.lancamentoCaixa
        }
        
        this.showLoading();
        this.liberarRepasse(this.reciboRecuperado)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.concluirPagamento(resultado);
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
      } else {
        if(!this.calculado) {
          this.exibirAlert("Atenção", "Você deve calcular o valor do pagamento antes de dar baixa no pagamento");	
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      }
    },
    
    dadosValidos() {
      var validacao = true;
      
      validacao = this.calculado && validacao;
      validacao = this.reciboRecuperado.formaPagamento && validacao;
      
      if(this.boleto) {
        validacao = this.reciboRecuperado.dataCreditoPagamento && validacao;
      }
      
      if(this.transferenciaBancaria && this.contaBancariaNaoSelecionada) {
        validacao = false;
      }
      
      return validacao;
    },

    formatarValor(valor) {
      return Util.formatarValor(valor)
    },
    labelTipoRecibo(item){
      return Util.getLabel(this.tipoItem,item.tipo)
    },
    labelValor(item) {
      return Util.formatarValor(item.valor)
    },

    // CONTA ORIGEM
    exibirSelecionarContaBancariaOrigemDialog() {
      this.clienteConta = undefined
      this.visibilidadeSelecionarContaBancariaOrigemDialog = true
    },
    fecharSelecionarContaBancariaOrigemDialog(contaBancaria) {
      if(contaBancaria && contaBancaria.id !== 0){
        this.contaBancariaOrigem = contaBancaria
      }
      this.visibilidadeSelecionarContaBancariaOrigemDialog = false;
    },
    // CONTA DESTINO
    exibirSelecionarContaBancariaDestinoDialog() {
      this.clienteConta = this.reciboRecuperado.cliente
      this.visibilidadeSelecionarContaBancariaDestinoDialog = true
    },
    fecharSelecionarContaBancariaDestinoDialog(contaBancaria) {
      if(contaBancaria && contaBancaria.id !== 0){
        this.contaBancaria = contaBancaria
      }
      this.visibilidadeSelecionarContaBancariaDestinoDialog = false;
    },

    exibirDetalhesLancamentoCaixaDialog() {
        this.visibilidadeDetalhesLancamentoCaixaDialog = true
    },
    fecharDetalhesLancamentoCaixaDialog() {
        this.visibilidadeDetalhesLancamentoCaixaDialog = false
    },

    exibirAlert(titulo, mensagem) {
        this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    reset(){
      this.reciboRecuperado = {
        dataProrrogacao: Date,
        itensRecibo: []
      },

      this.dataPagamento = Util.hoje(),
      this.calculado = false,

      this.contaBancariaOrigem = {
        id: 0,
        nome: ''
      },

      this.contaBancaria = {
        id: 0,
        nome: ''
      },

      this.clienteConta = {}
    },
    concluirPagamento(resultado) {
      this.reset();
      this.$emit('concluirPagamento',resultado);
    },
    fechar() {
      this.reset();
      this.$emit('close');
    } 
  }
}
</script>
